import { render, staticRenderFns } from "./GyLogo.vue?vue&type=template&id=270ffa63&"
import script from "./GyLogo.vue?vue&type=script&lang=js&"
export * from "./GyLogo.vue?vue&type=script&lang=js&"
import style0 from "./GyLogo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports